import { RootState } from "../store";

export const selectRefreshTokenEmmitQuote = (state: RootState) => state.emmitQuote.refreshToken;
export const selectEmmitQuoteData = (state: RootState) => state.emmitQuote.data;
export const selectErrorMessageEmmitQuote = (state: RootState) => state.emmitQuote.errorMessage;
export const selectCanGoBackEmmitQuote = (state: RootState) => state.emmitQuote.canGoBack;